export default "__VITE_ASSET__C3ljs0zu__$_?no-inline__"